export enum RouteNotenmodulMenuGroup {
	ALLGEMEIN = "Noteneingabe",
	ADMINISTRATION = "Administration"
}
